
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brand]/terms-and-conditions",
      function () {
        return require("private-next-pages/[brand]/terms-and-conditions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brand]/terms-and-conditions"])
      });
    }
  